import React, { useState, useRef, useEffect } from 'react';
import {
  DropdownMenu,
  DropdownItem,
  DropdownHeader,
  DropdownDivider,
  Dropdown,
  Input,
  Icon,
  Button,
} from 'semantic-ui-react';

const styles = document.createElement('style');
styles.innerHTML = `
  .non-active-item:hover {
    background-color: var(--accent) !important;
  }
`;
document.head.appendChild(styles);

const DropdownFile = ({ label, userProjects = [] }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [isOpen, setIsOpen] = useState(false);
  const searchInputRef = useRef(null);

  const handleSearchChange = (e, { value }) => {
    setSearchQuery(value);
  };

  // Ref to track if we're in the middle of focusing
  const isFocusingRef = useRef(false);

  // Auto-focus search input when dropdown opens
  useEffect(() => {
    if (isOpen && userProjects.length > 10) {
      // Use setTimeout to ensure the input is rendered and ready
      isFocusingRef.current = true;
      setTimeout(() => {
        if (searchInputRef.current && searchInputRef.current.inputRef && searchInputRef.current.inputRef.current) {
          searchInputRef.current.inputRef.current.focus();
        }
        // Reset the focusing flag after a short delay
        setTimeout(() => {
          isFocusingRef.current = false;
        }, 100);
      }, 100);
    }
  }, [isOpen, userProjects.length]);

  const handleDropdownOpen = () => {
    setIsOpen(true);
  };

  const handleClose = () => {
    // Don't close if we're in the middle of focusing the search input
    if (isFocusingRef.current) {
      return;
    }
    setIsOpen(false);
  };

  const handleClick = (e) => {
    e.stopPropagation();
  };

  const handleItemClick = (project) => {
    if (!project.opened) {
      window.open(project.url, '_self');
      handleClose();
    }
  };

  const filteredProjects = userProjects.filter((file) =>
    file.text.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <>
      <Dropdown
        trigger={
          <Button
            style={{
              backgroundColor: label === 'public' ? 'var(--chart-4)' : 'var(--secondary)',
              color: 'var(--secondary-foreground)',
              border: 'none',
              boxShadow: 'none',
              display: 'flex',
              alignItems: 'center',
              padding: '0.5em 0.8em',
              height: '32px',
              minWidth: label === 'public' ? '40px' : '60px',
              width: label === 'public' ? '40px' : 'auto'
            }}
            compact
            size='mini'
            className='aligned'
          >
            {label === 'public' ? (
              <Icon name='folder open' style={{ margin: '0' }} />
            ) : (
              l.load
            )}
            <Icon name='dropdown' style={{
              marginLeft: '2px',
              fontSize: '12px',
              opacity: 0.8
            }} />
          </Button>
        }
        icon={null}
        floating
        pointing='top'
        className='link item custom-dropdown'
        open={isOpen}
        onOpen={handleDropdownOpen}
        onClose={handleClose}
        onClick={handleClick}
      >
        <Dropdown.Menu style={{ background: 'var(--popover)', boxShadow: 'var(--shadow-lg)', minWidth: '300px', opacity: 1, zIndex: 100001 }}>
          {userProjects.length > 10 && (
            <div className='ui input' style={{
              padding: '12px',
              borderBottom: '1px solid var(--border)',
              background: 'var(--popover)'
            }}>
              <Input
                transparent
                icon={<Icon name='search' style={{ color: 'var(--muted-foreground)' }} />}
                iconPosition='left'
                value={searchQuery}
                onChange={handleSearchChange}
                placeholder={l.search + '...'}
                ref={searchInputRef}
                onClick={(e) => e.stopPropagation()}
                size='small'
                style={{
                  width: '100%',
                  background: 'var(--accent)',
                  border: '1px solid var(--input)',
                  borderRadius: 'var(--radius)',
                  padding: '6px 12px',
                  color: 'var(--foreground)',
                  '::placeholder': {
                    color: 'var(--muted-foreground)',
                    opacity: 1
                  }
                }}
              />
            </div>
          )}
          <Dropdown.Header
            content={l.projects}
            style={{
              padding: '12px 16px',
              fontWeight: '600',
              color: 'var(--popover-foreground)',
              fontSize: '14px',
              borderBottom: '1px solid var(--border)'
            }}
          />
          <Dropdown.Menu scrolling style={{
            maxHeight: '400px',
            padding: '8px 0',
            opacity: 1,
            background: 'var(--popover)'
          }}>
            {filteredProjects.map((file) => (
              <Dropdown.Item
                key={file.id}
                text={file.text}
                active={file.opened}
                disabled={file.opened}
                onClick={() => handleItemClick(file)}
                style={{
                  padding: '10px 16px',
                  color: file.opened ? 'var(--destructive-foreground)' : 'var(--popover-foreground)',
                  background: file.opened ? 'var(--destructive)' : 'transparent',
                  transition: 'background-color 0.2s ease',
                  cursor: file.opened ? 'default' : 'pointer',
                  fontWeight: file.opened ? '500' : 'normal',
                  opacity: 1
                }}
                className={!file.opened ? 'non-active-item' : ''}
              />
            ))}
          </Dropdown.Menu>
        </Dropdown.Menu>
      </Dropdown>
    </>
  );
};

export default DropdownFile;
